import { c as _c } from "react/compiler-runtime";
import { SignInButton as SignInButtonClerk, SignOutButton as SignOutButtonClerk, Show, useAuth, useOrganization } from "@clerk/nextjs";
import { EDRA_ORG_SLUG } from "./shared";
import { Button } from "@/components/ui/button";
import type { ButtonProps } from "@/components/ui/button";
import type { ComponentProps, ReactNode } from "react";
const SignOutButton = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SignOutButtonClerk redirectUrl="/sign-in" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Button asChild={true} {...props}>{t0}</Button>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const SignInButton = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SignInButtonClerk />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Button asChild={true} {...props}>{t0}</Button>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const usePermissions = () => {
  const $ = _c(5);
  const {
    has,
    isLoaded
  } = useAuth();
  let t0;
  if ($[0] !== has) {
    t0 = has?.({
      role: "org:admin"
    });
    $[0] = has;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAdmin = t0;
  let t1;
  if ($[2] !== isAdmin || $[3] !== isLoaded) {
    t1 = {
      isLoaded,
      canEdit: isAdmin,
      canManageReviewSla: isAdmin,
      canSeeSharedInbox: isAdmin
    };
    $[2] = isAdmin;
    $[3] = isLoaded;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};

// Preserve the `<SignedIn>` / `<SignedOut>` API surface for consumers by wrapping `<Show>`.
const SignedIn = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Show when="signed-in">{children}</Show>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const SignedOut = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Show when="signed-out">{children}</Show>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export { UserButton, SignIn, SignUp } from "@clerk/nextjs";
const useIsEdraOrg = () => {
  const {
    organization
  } = useOrganization();
  return organization?.slug === EDRA_ORG_SLUG;
};
export { SignedIn, SignedOut, SignInButton, SignOutButton, usePermissions, useIsEdraOrg };